import { pickSources } from "./sourceRegistry";

export const peopleProfiles = {
  robShell: {
    id: "rob-shell",
    displayName: "Rob Shell",
    fullName: "Robert Hillman Shell",
    aliases: ["Rob Shell", "Robert Hillman Shell"],
    publicRoles: ["Mortgage Loan Originator"],
    organizations: ["Mutual of Omaha Mortgage"],
    locations: ["Brentwood, Tennessee"],
    identifiers: ["NMLS 2226086"],
    linkedInPath: "linkedin.com/in/rob-shell-93622325/",
    linkedInUrl: "https://www.linkedin.com/in/rob-shell-93622325/",
    license: {
      label: "NMLS ID",
      value: "2226086",
      displayValue: "NMLS ID #2226086",
      status: "source-established",
      sourceKeys: ["robShellOfficial", "nmlsConsumerAccess"],
    },
    professionalContext: {
      organization: "Mutual of Omaha Mortgage",
      role: "Mortgage Loan Originator",
      status: "public-company-profile-listed",
      sourceKeys: ["robShellOfficial"],
    },
    sourceKeys: ["robShellOfficial", "robShellLinkedIn", "nmlsConsumerAccess"],
    issueTags: [
      "DSCR loan",
      "non-QM interest-only",
      "loan-option presentation",
      "anti-steering review",
      "Mutual of Omaha Mortgage",
    ],
    complaintContext:
      "The complaint identifies Robert Hillman Shell as the Mutual of Omaha Mortgage professional involved in the disputed Dupont loan transactions.",
    privacyNote:
      "This site lists public professional identifiers only and omits personal contact details.",
  },
  vickiSmith: {
    id: "vicki-smith",
    displayName: "Vicki Smith",
    fullName: "Vicki Smith",
    aliases: ["Vicki Smith"],
    publicRoles: ["New Home Sales Consultant", "Affiliate broker / sales counselor in complaint materials"],
    organizations: ["PulteGroup", "Legacy South"],
    locations: ["Nashville Metropolitan Area", "Soren development, Madison, Tennessee"],
    identifiers: ["LinkedIn public profile"],
    linkedInPath: "linkedin.com/in/vicki-smith-davidweekleyhomes/",
    linkedInUrl: "https://www.linkedin.com/in/vicki-smith-davidweekleyhomes/",
    license: {
      label: "License number",
      value: null,
      displayValue: "Not established by current cited sources.",
      status: "not-established-by-current-cited-sources",
      sourceKeys: [
        "vickiSmithLinkedIn",
        "homesSorenUnit303",
        "pulteGroupLinkedIn",
        "pulteTennesseeLinkedIn",
      ],
    },
    professionalContext: {
      organization: "PulteGroup",
      role: "New Home Sales Consultant",
      status: "public-profile-listed",
      sourceKeys: ["vickiSmithLinkedIn", "pulteGroupLinkedIn", "pulteTennesseeLinkedIn"],
      listingAssociation: {
        organization: "Pulte Homes Tennessee",
        status: "public-listing-record-listed",
        sourceKeys: ["homesSorenUnit303"],
        limitation:
          "This listing-record association is public professional context only and is not proof of the complaint allegations.",
      },
    },
    sourceKeys: [
      "vickiSmithLinkedIn",
      "homesSorenUnit303",
      "pulteGroupLinkedIn",
      "pulteTennesseeLinkedIn",
    ],
    issueTags: [
      "new home sales",
      "PulteGroup",
      "Legacy South",
      "Soren",
      "earnest-money pressure",
      "closing coordination",
    ],
    complaintContext:
      "The complaint identifies Vicki Smith in the Legacy South sales context and alleges closing pressure tied to earnest-money risk.",
    privacyNote:
      "This site lists public professional and complaint-record details only and omits personal contact details.",
  },
  mackenzieCurtis: {
    id: "mackenzie-curtis",
    displayName: "Mackenzie Curtis",
    fullName: "Mackenzie Curtis",
    aliases: ["Mackenzie Curtis"],
    publicRoles: ["Divisional Builder Manager", "Regional Vice President, Builder Division in the complaint record"],
    organizations: ["Acrisure Mortgage", "Mutual of Omaha Mortgage in the complaint record"],
    locations: ["Nashville, Tennessee"],
    identifiers: ["NMLS 471956"],
    publicProfileUrl: "https://acrisuremortgage.com/mcurtis/",
    publicProfileLabel: "Mackenzie Curtis's current official profile",
    license: {
      label: "NMLS ID",
      value: "471956",
      displayValue: "NMLS ID #471956",
      status: "source-established",
      sourceKeys: ["mackenzieCurtisOfficial", "nmlsConsumerAccess"],
    },
    professionalContext: {
      organization: "Acrisure Mortgage",
      role: "Divisional Builder Manager",
      status: "current-public-company-profile-listed",
      sourceKeys: ["mackenzieCurtisOfficial"],
    },
    referenceNote:
      "The submitted complaint identifies Mackenzie Curtis as a Mutual of Omaha Mortgage Regional Vice President, Builder Division, in August 2025. Her current official profile lists Acrisure Mortgage, so this site does not imply an ongoing Mutual affiliation.",
    sourceKeys: [
      "mackenzieCurtisOfficial",
      "nmlsConsumerAccess",
      "submittedComplaintPublicCopy",
    ],
    issueTags: ["builder lending", "loan-option presentation", "Mutual of Omaha Mortgage"],
    complaintContext:
      "The complaint identifies Mackenzie Curtis as the Mutual of Omaha Mortgage representative who provided rate options and loan structures in August 2025.",
    privacyNote:
      "This site lists public professional identifiers only and omits direct contact details.",
  },
  tonyFragale: {
    id: "tony-fragale",
    displayName: "Tony Fragale",
    fullName: "Tony Fragale",
    aliases: ["Tony Fragale"],
    publicRoles: ["Branch Manager", "Vice President of Mortgage Lending"],
    organizations: ["Mutual of Omaha Mortgage"],
    identifiers: ["NMLS 76480"],
    publicProfileUrl: "https://www.mutualmortgage.com/loan-officer/tfragale/",
    license: {
      label: "NMLS ID",
      value: "76480",
      displayValue: "NMLS ID #76480",
      status: "source-established",
      sourceKeys: ["tonyFragaleOfficial"],
    },
    professionalContext: {
      organization: "Mutual of Omaha Mortgage",
      role: "Branch Manager, Vice President of Mortgage Lending",
      status: "public-company-profile-listed",
      sourceKeys: ["tonyFragaleOfficial"],
    },
    dossierConnection: {
      status: "not-established-by-current-cited-sources",
      statement:
        "The cited official profile establishes public professional context only; it does not identify a connection to the Dupont complaint.",
    },
    sourceKeys: ["tonyFragaleOfficial"],
    privacyNote:
      "This site lists public professional identifiers only and omits personal contact details.",
  },
};

// These are the three people requested for direct reference across the major
// dossier pages. Current and complaint-era affiliations stay explicitly distinct.
export const dossierPeopleRecords = [
  peopleProfiles.robShell,
  peopleProfiles.vickiSmith,
  peopleProfiles.mackenzieCurtis,
];

// Neutral, source-linked organizational context for templates. These fields do
// not establish responsibility for, or a connection to, the Dupont allegations.
export const companyContextRecords = {
  mutualOfOmahaMortgage: {
    id: "mutual-of-omaha-mortgage",
    displayName: "Mutual of Omaha Mortgage",
    sourceKeys: ["mutualMortgageHome"],
    leadership: [
      {
        personId: peopleProfiles.tonyFragale.id,
        displayName: peopleProfiles.tonyFragale.displayName,
        role: peopleProfiles.tonyFragale.professionalContext.role,
        license: peopleProfiles.tonyFragale.license,
        publicProfileUrl: peopleProfiles.tonyFragale.publicProfileUrl,
        sourceKeys: peopleProfiles.tonyFragale.sourceKeys,
        dossierConnection: peopleProfiles.tonyFragale.dossierConnection,
      },
    ],
  },
  pulteGroup: {
    id: "pultegroup",
    displayName: "PulteGroup",
    sourceKeys: ["pulteGroupLinkedIn", "pulteTennesseeLinkedIn"],
    professionalAssociation: {
      personId: peopleProfiles.vickiSmith.id,
      displayName: peopleProfiles.vickiSmith.displayName,
      role: peopleProfiles.vickiSmith.professionalContext.role,
      status: peopleProfiles.vickiSmith.professionalContext.status,
      sourceKeys: peopleProfiles.vickiSmith.professionalContext.sourceKeys,
      limitation:
        "This public professional context does not establish that PulteGroup or Vicki Smith committed wrongdoing.",
    },
  },
};

export const peopleProfileList = Object.values(peopleProfiles);

export function getProfileSources(profile) {
  return pickSources(profile.sourceKeys);
}
